<template>
  <popup :open.sync="open">
    <div class="popup-header">
      <h3>New Card Request</h3>
    </div>
      <div class="scrollable">
        <template>
          <div class="content-form">
            <div class="form-row form-split">
              <form-field-select v-model="form.cardType" label="Select Card Type" :validator="$v.form.cardType" :options="cardTypeOptions" required />
            </div>
            <div class="form-row form-fullw">
              <form-field-text v-model="form.label" label="Label" />
            </div>
            <div class="form-row form-split">
              <div>
                <h3 v-if="balanceError" class="error-message">Insufficient Balance to issue card. Please verify fee and balance</h3>
              </div>
            </div>
          </div>
        </template>
        <div class="buttons">
          <button class="main" @click="add()">Submit</button>
          <button class="second" @click="open = false">Cancel</button>
          <label v-if="submitError" class="error-message">Please check error(s) and try again.</label>
        </div>
      </div>
  </popup>
</template>

<script>
import { required, numeric, minLength, maxLength, maxValue, decimal, minValue } from 'vuelidate/lib/validators'

export default {
  props: {
    modalType: {
      type: String,
      required: true
    },

    account: {
      type: Object,
      required: true
    },

    registration: {
      type: Object,
      required: true
    }
  },

  components: {
  },

  data () {
    return {
      form: {
        cardType: null,
        label: null,
      },
      system: null,

      featureStatusPhysicalCards: false,
      featureStatusVirtualCards: false,
      open: true,
      submitError: false,
      balanceError: false,
    }
  },

  computed: {
    currentUser () {
      return window.appData.currentUser
    },

    isCustomer () {
      return this.currentUser.isCustomer
    },

    reg () {
      return this.$store.getters['registrations/get'](this.currentUser.regId)
    },

    cardTypeOptions () {
      const options = []
      if(this.featureStatusPhysicalCards) {
        options.push(
          {
            id: 'physical',
            text: 'Physical',
          }
        )
      }
      if(this.featureStatusVirtualCards) {
        options.push(
          {
            id: 'virtual',
            text: 'Virtual',
          }
        )
      }
      return options
    },

    now () {
      return moment().subtract(window.serverDiff, 's')
    },
  },

  watch: {
    open (open) {
      if (!open) this.$emit('close')
    },
  },

  methods: {
    async add () {
      this.$v.$touch()
      if (this.$v.form.$invalid) {
        this.submitError = true
        return
      }

      this.balanceError = false
      this.submitError = false
      const loader = this.$loading.show()
      let payload;

      const response = (await this.$store.dispatch('cards/action', {
        id: 'new',
        action: 'IssueCard',
        payload: {
          account: this.account.id,
          cardType: this.form.cardType,
          label: this.form.label,
        }
      }))
      if(response.action.error) {
        this.$toast.error('Error: ' + response.action.errorMsg)
        this.$toast.error('Card Not Created.')
      }else{
        this.$store.dispatch('registrations/get', this.registration.id)
        this.open = false
        this.$toast.success('Card successfully created.')
      }
      loader.hide()
    },

    async getFeatureStatus () {
      this.featureStatusPhysicalCards = window.systemFeatures['Physical Cards']
      this.featureStatusVirtualCards = window.systemFeatures['Virtual Cards']
    },
  },

  async created () {
    this.system = JSON.parse(JSON.stringify(window.appData.system))
    await this.getFeatureStatus();
    await this.$store.dispatch('fee_schedule/load')
  },

  validations () {
    let rules = {}
    rules = {
      form: {
        cardType: { required },
      }
    }

    return rules
  }
}
</script>

<style lang="scss" scoped>
.buttons {
  margin-top: 30px;
}
.template-check {
  display: flex;
  align-items: center;

  input {
    display: inline-block !important;
    width: 20px !important;
    height: 20px !important;
  }

  label {
    display: inline !important;
    position: unset !important;

    &:before {
      position: unset !important;
    }
  }
}

input::selection {
  background: #0000ff;
  color: #fff;
}
.depositType {
  justify-content: center;
}

.information p {
  margin: 5px;
}

.wallet-address {
  font-size: 17px;
}
.form-max {
  div {
    width: 100%;
  }
}
.paddingless {
  padding: 0 !important;
}

.address-line {
  margin: 0;
}
</style>